import { css } from '@emotion/css';
import colors from '@/theme/colors';
import {
  BodyLarge,
  BodyMedium,
  ButtonOutlineSmall,
  TitleLargeEmphasized,
  ButtonFlatSmall,
} from '@/design-system';

type Props = {
  email: string;
  resendMagicLinkHandler: () => void;
  updateEmailHandler: () => void;
};

const MagicLinkSuccess = ({ email, resendMagicLinkHandler, updateEmailHandler }: Props) => (
  <div className={styles.container}>
    <TitleLargeEmphasized>Your email is on its way!</TitleLargeEmphasized>
    <div className={styles.emailConfirmation}>
      <BodyLarge>
        We sent an email to {email} with a magic log in link that will safely log you into your
        account automatically.
      </BodyLarge>
    </div>
    <BodyMedium color={colors.slate}>
      Note: The magic log in link will expire in 72 hours.
    </BodyMedium>
    <div className={styles.ctaSection}>
      <BodyMedium>
        Didn't get the email? Resend it or update your email address if it's not correct.
      </BodyMedium>
      <div className={styles.ctaSectionOptions}>
        <div className={styles.buttonUpdateEmail}>
          <ButtonFlatSmall onClick={updateEmailHandler}>Update Email</ButtonFlatSmall>
        </div>
        <span className={styles.buttonResend}>
          <ButtonOutlineSmall onClick={resendMagicLinkHandler} background="transparent">
            resend
          </ButtonOutlineSmall>
        </span>
      </div>
    </div>
  </div>
);

const styles = {
  container: css`
    padding: 0px 16px 0px 16px;
  `,
  emailConfirmation: css`
    padding: 24px 0px;
  `,
  ctaSection: css`
    gap: 10px;
    margin-top: 32px;
    padding: 24px;
    border-radius: 12px;
    background-color: ${colors.platinum};
    padding: 24px;
  `,
  ctaSectionOptions: css`
    width: 100%;
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  `,
  buttonUpdateEmail: css`
    padding-right: 10px;
  `,
  buttonResend: css`
    .MuiButton-root {
      text-transform: lowercase !important;
    }
  `,
};

export default MagicLinkSuccess;
